import { conditions } from "../helpers/conditions/conditions";
import { flattenObject, getUUID } from "../helpers/helpers";
import { ConditionName, ContentTypesString } from "../interfaces/enums";
import { IDetails, IParams } from "../interfaces/interfaces";
import store from "../redux/store";
import { videoTag } from "../helpers/constants";
import { handleContentType } from "redux-share/actions";

export const feedbackLog = (starNum: Number, reasons: string[], customText: string | undefined) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "feedback",
        id: Number(params.id),
        stars: starNum ? starNum : starNum,
        text: reasons,
        customText: customText,
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const eventMarkerClickLog = (markerId: Number, markerTime: Number, markerTitle: String, markerDescription: String, markerSticker: String) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "eventMarkerClick",
        video_id: conditions(ConditionName.isLiveParam) ? details.id : Number(params.id),
        markerId: markerId,
        markerTime: markerTime,
        markerTitle: markerTitle,
        markerDescription: markerDescription,
        markerSticker: markerSticker,
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const speedChangeLog = (selectedSpeed: Number) => {
    const { params, details } = store.getState().videoData;
    const { settings } = store.getState().user;
    return {
        category: "speedChange",
        previousSelectedSpeed: settings.speed,
        selectedSpeed: selectedSpeed,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const qualityChangeRequestLog = (selectedQuality: String) => {
    const { params, details } = store.getState().videoData;
    const { qualityLevels, manualQuality, autoQuality } = store.getState().controller;
    return {
        category: "qualityChangeRequest",
        currentPlayingQuality: `${qualityLevels[conditions(ConditionName.isAutoQuality) ? autoQuality ?? manualQuality! : manualQuality!]}P`,
        previousSelectedQuality: conditions(ConditionName.isAutoQuality) ? "auto" : `${qualityLevels[manualQuality!]}P`,
        selectedQuality: selectedQuality,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const catchUpLoadingLog = (duration: number) => {
    const { params, details } = store.getState().videoData;
    const { hlsLiveSyncPosition, qualityLevels, autoQuality } = store.getState().controller;
    const { settings } = store.getState().user;

    return {
        category: "catchUpLoading",
        previousVideoTime: Number(sessionStorage.getItem("previousVideoTime")),
        currentVideoTime: hlsLiveSyncPosition,
        duration: duration,
        quality: `${conditions(ConditionName.isAutoQuality) ? qualityLevels[autoQuality!] : qualityLevels[settings.quality]}P`,
        isAutoQuality: conditions(ConditionName.isAutoQuality),
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const shareDialogLog = (videoTime: number, isJump: boolean, jumpTime: number | undefined, eventMarkerId?: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "shareDialog",
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        videoTime: videoTime,
        eventMarkerId: eventMarkerId,
        provider: params.provider,
        jump: isJump ? "true" : "false",
        jumpTime: isJump ? jumpTime : undefined
    };
};

export const shareCopyLog = (videoTime: number, isJump: boolean, jumpTime: number | undefined, EventMarker?: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "shareCopy",
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        videoTime: videoTime,
        eventMarkerId: EventMarker,
        jump: isJump ? "true" : "false",
        jumpTime: isJump ? jumpTime : undefined,
        provider: params.provider
    };
};

export const alternativeLiveLog = (alternativeLiveUserId: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "alternativeLiveClick",
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        alternativeLiveUserId: alternativeLiveUserId,
        provider: params.provider
    };
};

export const deActiveSettingLog = () => {
    const { params, details } = store.getState().videoData;
    const { settings } = store.getState().user;
    let data_base = {
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
    if (!settings.poll_emoji) {
        return {
            ...data_base,
            category: "deactiveSetting",
            hasOtherLive: conditions(ConditionName.hasAlternativeLives) ? "true" : "false",
            hasPoll: conditions(ConditionName.hasPoll) ? "true" : "false",
            hasEmoji: conditions(ConditionName.hasEmojiList1Or2) ? "true" : "false"
        };
    } else
        return {
            ...data_base,
            category: "activeSetting"
        };
};

export const backwardForwardLog = (type: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: type === "backward" ? "backward" : "forward",
        id: Number(params.id),
        type: params.type,
        src: details.stream_link ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const pollModalCloseLog = (params: IParams, details: IDetails, pollId: number) => {
    return {
        category: "pollModalClose",
        pollId: pollId,
        id: Number(params.id),
        type: params.type,
        src: details.stream_link ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const tagClickLog = (tagText: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "tagClick",
        tagText: tagText,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const likeDislikeLog = (category: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: category,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const fullscreenLog = (category: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: category,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const brightnessLog = (source: number, target: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "brightnessChange",
        source: source,
        target: target,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const volumeLog = (source: number, target: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "volumeChange",
        source: source,
        target: target,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const subtitleLog = (language: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "subtitle",
        language: language,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const lockLog = (category: string) => {
    const { params, details } = store.getState().videoData;
    return {
        category: category,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const recommendationListLog = (targetVideoId: number, targetUserId: number, targetType: string, listIndex: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "recommend",
        sourcevideoId: conditions(ConditionName.isLiveParam) ? details.id : +params.id!,
        targetVideoId: targetVideoId,
        sourceUserId: details.user_id,
        targetUserId: targetUserId,
        sourceType: params.type,
        targetType: targetType,
        listIndex: listIndex,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const ExceptionsLog = (type: string, message: string) => {
    return {
        category: "error",
        type: type,
        message: message
    };
};

export const videoTimelineLog = (start: number, end: number) => {
    const { params, details } = store.getState().videoData;
    const { duration } = store.getState().controller;
    return {
        category: "video-timeline",
        video_id: conditions(ConditionName.isLiveParam) ? details.id : +params.id!,
        video_type: params.type === "archive" ? "live" : params.type,
        start: start,
        end: end,
        watchedDuration: end - start,
        video_duration: conditions(ConditionName.isLiveParam) ? null : Math.floor(duration),
        clientUUID: getUUID(),
        user_id: conditions(ConditionName.isLiveParam) ? params.id : details.user_id,
        content_type: details.content_type,
        content_id: details.content_id
    };
};

export const bookmarkLog = (category: "bookmark" | "unBookmark") => {
    const { params, details } = store.getState().videoData;
    return {
        category: category,
        id: conditions(ConditionName.isLiveParam) ? details.id : +params.id!,
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src
    };
};

export const autoQualityChangeLog = (sourceQuality: String, targetQuality: String, diffQuality: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "autoQualityChange",
        sourceQuality: sourceQuality,
        targetQuality: targetQuality,
        diffQuality: diffQuality,
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const pingpongLog = (startTimer: number, qualityHistory: number[]) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "pingpong",
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        PingPongDuration: Number((new Date().getTime() - startTimer).toFixed(2)),
        PingPongSourceQuality: `${qualityHistory[0]}P`, // A     A->B && B->A
        PingPongTargetQuality: `${qualityHistory[1]}P`, // B,
        provider: params.provider
    };
};

export const pausePlayLog = (isPlay: boolean) => {
    const { params, details } = store.getState().videoData;
    return {
        category: isPlay ? "playVideo" : "pauseVideo",
        id: Number(params.id),
        type: params.type,
        src: details.stream_link ? details.stream_link : params.src,
        provider: params.provider
    };
};

export const initLog = (loadingTime: number, waitingTime: number, bannerLoadingTime: number, firstChunkPlayingTime: number, timerRef: any) => {
    const { params, details } = store.getState().videoData;
    const totalTime = Date.now() - timerRef.current + loadingTime + waitingTime;
    const memory = (window.performance as any).memory;
    const timing = JSON.parse(JSON.stringify((window.performance as any).timing));
    return {
        category: "initLog",
        id: Number(params.id),
        type: params.type,
        origin: new URL(conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src!).origin,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        loading: loadingTime,
        bannerLoading: !conditions(ConditionName.hasBanner) || bannerLoadingTime < 0 ? 0 : bannerLoadingTime,
        waiting: waitingTime,
        firstChunkPlaying: firstChunkPlayingTime < 0 ? 0 : firstChunkPlayingTime,
        totalTime: totalTime,
        provider: params.provider,
        performance: flattenObject({ memory, timing }, "performance"),
        userAgent: window.navigator.userAgent
    };
};

export const loadingLog = (waitingDuration: number, qualityLevel: number, timerRef: any, loadingCounterRef: any, videoEntranceTime: number) => {
    const { params, details, hlsLiveSyncPosition } = store.getState().videoData;
    const { settings } = store.getState().user;
    const videoTime = conditions(ConditionName.isLiveParam) ? hlsLiveSyncPosition : videoTag().currentTime;
    const previousLoaderDiff = Date.now() - timerRef.current;
    return {
        category: "loading",
        id: Number(params.id),
        type: params.type,
        src: conditions(ConditionName.hasStreamLink) ? details.stream_link : params.src,
        duration: waitingDuration,
        quality: `${qualityLevel}P`,
        isAutoQuality: conditions(ConditionName.isAutoQuality),
        previousLoaderDiff: previousLoaderDiff,
        counter: loadingCounterRef.current,
        loadingPercentile: Number((waitingDuration / previousLoaderDiff).toFixed(2)),
        videoTime: videoTime,
        videoEntranceTime: videoEntranceTime,
        speed: settings.speed,
        provider: params.provider
    };
};

export const playListClickLog = (playlistId: number) => {
    const { params, details } = store.getState().videoData;
    return {
        category: "playListClick",
        playlistId: playlistId,
        id: conditions(ConditionName.isLiveParam) ? details.id : +params.id!,
        type: params.type
    };
};

export const videoOfPlaylistClickLog = (playlistId: number, videoId: number, videoType: number, videoIndex: number) => {
    return {
        category: "videoOfPlaylistClick",
        tag: playlistId,
        indexNumber: videoIndex,
        videoId: videoId,
        videoType: videoType
    };
};

export const searchLog = (
    contentType: undefined | ContentTypesString.PlayList | ContentTypesString.Vod | `${ContentTypesString.Vod},${ContentTypesString.PlayList}`
) => {
    const { selectedTags, inputTagSearch } = store.getState().tags;
    const { params } = store.getState().videoData;
    return {
        category: "search",
        tag: selectedTags.join(","),
        q: conditions(ConditionName.hasInputTagSearch) ? inputTagSearch : undefined,
        user_ids: params.user_ids,
        video_type: contentType
    };
};

export const searchResultClickLog = (videoId: number, videoType: string, videoIndex: number) => {
    const { selectedTags, inputTagSearch } = store.getState().tags;
    const { params } = store.getState().videoData;
    const contentType = handleContentType();
    return {
        category: "searchResultClick",
        tag: selectedTags.join(","),
        q: conditions(ConditionName.hasInputTagSearch) ? inputTagSearch : undefined,
        user_ids: params.user_ids,
        video_type: contentType,
        clickedId: videoId,
        clickedIndex: videoIndex,
        clickedType: videoType
    };
};
